import(/* webpackMode: "eager" */ "/vercel/path0/src/app/forum/page.tsx");
